import { Log, apiRequest } from '@ext/utils'; import { Paginacion } from '@ext/env';
export * from './Pedido.types';
import { IPedido } from './Pedido.lib';
import { Envio } from '../Envios';
import { Cliente } from '../../Clientes';
import { Pago } from '../Pagos';
import { Item } from './Item';
import { Estados } from './Pedido.types';
import { Pregunta } from '../../MercadoLibre/Preguntas';
import { Publicacion } from '../../MercadoLibre/Publicaciones';
import querystring from 'query-string';
import { isNull, isNumber, isString, isArray } from 'util';
import { Observacion } from '@/__env/lib/Ventas/Pedidos/Observaciones';
import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
import { validarCuit, Utiles } from '@/__env/pluggins/event-bus';
import { ModificacionDeEstado } from '@/__env/lib/Ventas/Pedidos/Estados';
import { Mensaje } from '@/__env/lib/MercadoLibre/Chats/Mensajes';
import * as Pedidos from '@lib/Ventas/Pedidos';

export class Pedido extends IPedido
{

    public static async create ( id: number ): Promise<Pedido>
    {
        let o = new Pedido();
        o.Id = id;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }

    public static async createIdExterna ( idexterna: number, tipo: Pedidos.Tipos ): Promise<Pedido>
    {
        let o = new Pedido();
        o.IdExterna = idexterna;
        o.Tipo = tipo;
        if ( await o.find() )
        {
            return o;
        }
        return null;
    }


    protected Route: string = '/pedidos';
    protected async find (): Promise<boolean>
    {

        this.Existe = false;
        let request = new apiRequest();
        if ( this.IdExterna && this.Tipo && !this.Tipo.esNoEspecificado )
        {
            request.path = `${ this.Route }/`;
            request.params.tipo = this.Tipo.Id;
            request.params.id_externa = this.IdExterna;
            request.params.details = 'cliente,items,articulo,publicacion,envio,empresa_logistica';
            if ( await request.get() )
            {
                this.Json = request.data.results[0];
                this.set();
            }

        } else
        {
            request.path = `${ this.Route }/${ this.Id }`;
            request.params.details = 'cliente,items,articulo,publicacion,envio,empresa_logistica';
            if ( await request.get() )
            {
                this.Json = request.data;
                this.set();
            }
        }


        return this.Existe;
    }

    public static async find ( params: any ): Promise<{ Paginacion: Paginacion, Items: Array<Pedido>; Error?: boolean; }>
    {

        let a: Array<Pedido> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/pedidos` );
        request.params = params;
        if ( await request.get() )
        {
            if ( request.data.response )
            {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results )
            {
                for ( let i of request.data.results )
                {
                    let p = new Pedido( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

    public async save (): Promise<boolean>
    {

        try
        {
            let js = this.getJson();
            let req = new apiRequest();
            req.body = js;
            if ( this.Existe )
            {
                req.path = `${ this.Route }/${ this.Id }`;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }
            else
            {
                req.path = `${ this.Route }`;
                if ( await req.post() )
                {
                    this.Json = req.data;
                    this.set();
                    return true;
                }
            }

        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async del (): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${ this.Route }/${ this.Id }`;
                if ( await req.delete() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public static async DescargarVentaMercadoLibre ( cuenta: string, id: number )
    {
        let request = new apiRequest( `/mercadolibre/ordenes/e/${ cuenta }` );
        request.params = { id: id };

        if ( await request.post() )
        {
            return true;
        }
    }

    public static async DescargarVentasMercadoLibreRecientes ( cuenta: string ): Promise<{ Total: number, Proceso: string; }>
    {
        let request = new apiRequest( `/mercadolibre/ordenes/ex/recientes/${ cuenta }` );
        request.timeOut = 1000000;
        if ( await request.post() )
        {
            return { Total: request.data.total, Proceso: request.data.process };
        }
    }

    public async saveEstado ( estado: Estados ): Promise<boolean>
    {

        try
        {

            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `${ this.Route }/${ this.Id }`;
                req.body.estado = estado.Id;
                if ( await req.put() )
                {
                    this.Json = req.data;
                    return this.set();
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async AgregarPagos ( pagos: string[] ): Promise<boolean>
    {

        try
        {
            if ( this.Existe )
            {
                let req = new apiRequest();
                req.path = `/pedidos/pagos/${ this.Id }`;
                req.body.pagos = pagos.join( ',' );
                if ( await req.post() )
                {
                    return true;
                }
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async cargarCodigoAleatorio ( forzar?: boolean ): Promise<boolean>
    {
        try
        {
            if ( this.Tags.Pendiente && ( forzar || !this.CodigoAleatorio ) )
            {
                let req = new apiRequest();
                ///${this.Id}
                req.path = `${ this.Route }/aleatorio`;

                if ( await req.get() )
                {
                    this.CodigoAleatorio = req.data.codigo;
                    return true;
                }
            } else
            {
                console.log( 'eaea' );
            }
        } catch ( e )
        {
            Log( e );
        }
        return false;
    }

    public async CargarEnvio ()
    {
        this.Envio = await Envio.create( this.Json.envio.id ? this.Json.envio.id : this.Json.envio );
        if ( !this.Envio )
        {
            this.Envio = new Envio();
        }
    }

    public async CargarCliente ()
    {
        this.Cliente = await Cliente.create( this.Json.cliente.id ? this.Json.cliente.id : this.Json.cliente );
        if ( !this.Cliente )
        {
            this.Cliente = new Cliente();
        }
    }

    public async CargarPagos ()
    {
        let pagos = await Pago.find( { pedido: this.Id } );
        this.Pagos.clear();
        for ( let pago of pagos.Items )
        {
            this.Pagos.add( pago );
        }
    }

    public async CargarItems ()
    {
        let pagos = await Item.find( { pedido: this.Id, details: 'articulo,publicacion' } );
        this.Items.clear();
        for ( let pago of pagos.Items )
        {
            this.Items.add( pago );
        }
    }


    public async CargarHistorial ()
    {
        let pagos = await ModificacionDeEstado.find( this.Id, {} );
        this.Historial.clear();
        for ( let pago of pagos.Items )
        {
            this.Historial.add( pago );
        }
    }

    public async CargarPreguntas (): Promise<Pregunta[]>
    {
        return await ( await Pregunta.find(
            {
                usuario: this.Cliente.UsuarioMercadolibre,
                //publicacion: (this.Items[0].Publicacion as Publicacion).Id,
                cuenta: this.Cuenta,
                limit: 100
            } ) ).Items;
    }

    public async CargarMensajesNoLeidos (): Promise<number>
    {
        return await Mensaje.NoLeidos( { pack: this.Carrito } );
    }

    public async CargarMensajes (): Promise<number>
    {
        return await Mensaje.Todos( { pack: this.Carrito } );
    }

    public async CargarObservaciones (): Promise<Observacion[]>
    {
        return await ( await Observacion.find(
            {
                pedido: this.Id,
                limit: 100
            } ) ).Items;
    }

    public async CargarFacturas (): Promise<Factura[]>
    {
        return await ( await Factura.find(
            {
                pedido: this.Id,
                limit: 100
            } ) ).Items;
    }

    public async HabilitarPagoEnSucursal (): Promise<boolean>
    {
        let req = new apiRequest();
        req.path = '/pedidos/' + this.Id;
        req.body = { habilita_pago_presencial: 'S' };
        if ( await req.put() )
        {
            return true;
        }
    }

    public async BuscarEnviosDentroDePagos (): Promise<boolean>
    {
        let req = new apiRequest();
        req.path = `/pedidos/${ this.Id }/buscarenvios`;
        if ( await req.post() )
        {
            return true;
        }
    }


    public static async URLNotaDeVenta ( pedidos: Pedido[] ): Promise<string>
    {
        let req = new apiRequest();
        req.path = '/pedidos/nota_venta';
        req.params.ids = pedidos.map( x => x.Id ).join( ',' );
        req.params.response_type = 'pdf';
        if ( await req.get() )
        {
            return req.data.u;
        }
    }

    public static async URLNotaMercadoPago ( pedidos: Pedido[] ): Promise<string>
    {
        let req = new apiRequest();
        req.path = '/pedidos/notamercadopago';
        req.params.ids = pedidos.map( x => x.Id ).join( ',' );
        req.params.response_type = 'pdf';
        if ( await req.get() )
        {
            return req.data.u;
        }
    }

    public static async URLPresupuesto ( pedidos: Pedido[] ): Promise<string>
    {
        let req = new apiRequest();
        req.path = '/pedidos/presupuesto';
        req.params.ids = pedidos.map( x => x.Id ).join( ',' );
        req.params.response_type = 'pdf';
        if ( await req.get() )
        {
            return req.data.u;
        }
    }

    public static async URLFacturas ( pedidos: Pedido[] ): Promise<string>
    {
        let req = new apiRequest();
        req.path = '/facturas/archivos';
        req.params.pedidos = pedidos.map( x => x.Id ).join( ',' );
        req.params.response_type = 'pdf';
        if ( await req.get() )
        {
            return req.data.u;
        }
    }

    public static async URLHojaDePiso ( pedidos: Pedido[] | number ): Promise<string>
    {
        let req = new apiRequest();
        if ( isNumber( pedidos ) )
        {
            req.path = '/pedidos/hoja_de_piso/' + pedidos;
        }
        else
        {
            req.path = '/pedidos/hoja_de_piso';
            req.params.ids = pedidos.map( x => x.Id ).join( ',' );
        }
        req.params.response_type = 'pdf';
        if ( await req.get() )
        {
            return req.data.u;
        }

    }

    public static async DescargarEtiquetasEnvios ( pedidos: Pedido[] )
    {
        await Envio.AbrirEtiqueta( pedidos );
    }

    public static async URLEtiquetasItems ( pedidos: Pedido[] | number, etiquetadora: number = null ): Promise<boolean | string>
    {
        let req = new apiRequest();
        if ( isNumber( pedidos ) )
        {
            req.path = '/pedidos/etiquetas/items/' + pedidos;
        }
        else
        {
            req.path = '/pedidos/etiquetas/items';
            req.params.ids = pedidos.map( x => x.Id ).join( ',' );
        }

        if ( etiquetadora )
            req.params.etiquetadora = etiquetadora;
        else
            req.params.response_type = 'content';

        if ( await req.get() )
        {
            if ( etiquetadora )
                return true;
            else
                return req.response.data;
        }

    }

    public static async HojaDePisoUltimas (): Promise<{ id: number; descripcion?: string; }[]>
    {
        let req = new apiRequest();
        req.path = '/pedidos/hoja_de_piso/ultimas';
        if ( await req.get() )
        {
            return req.data;
        }
        return [];
    }

    public static async PendientesMla (): Promise<{ orders: number; }>
    {
        let req = new apiRequest();
        req.path = '/ventas/pedidos/mla/pendientes';
        if ( await req.get() )
        {
            return req.data;
        }

        return null;
    }

    public static async BuscarPedidosHojaDePiso ( hoja: number, enproceso: boolean = false ): Promise<Pedido[]>
    {
        let params = {
            limit: 50,
            hoja_piso: hoja,
            estado: 'en-proceso,facturado'
        };

        let pedidos: Pedido[] = [];
        let page = 0;
        while ( true )
        {
            page++;
            let request = new apiRequest( `/pedidos` );
            request.params = params;
            request.params.page = page;
            if ( await request.get() )
            {
                if ( isArray( request.data.results ) && Array( request.data.results ).hasRows() )
                {
                    for ( let ped of request.data.results )
                    {
                        pedidos.push( new Pedido( ped ) );
                    }

                } else
                {
                    break;
                }

                if ( request.data.response && request.data.response.paging.end )
                {
                    break;
                }

            } else
            {
                break;
            }
        }


        return pedidos;

    }

    public static async BuscarPedidosPendientes ( tipo: string, enproceso: boolean, soloenvios: boolean ): Promise<Pedido[]>
    {
        let params: any = {
            limit: 50,
            tipo: tipo,
            estado: 'pendiente,creado'
        };

        if ( enproceso )
            params.estado = 'pendiente,creado,en-proceso';
        if ( soloenvios )
            params.no_envio_tipo = 'retira-cliente,no-especificado';

        let pedidos: Pedido[] = [];
        let page = 0;
        while ( true )
        {
            page++;
            let request = new apiRequest( `/pedidos` );
            request.params = params;
            request.params.page = page;
            if ( await request.get() )
            {
                if ( isArray( request.data.results ) && Array( request.data.results ).hasRows() )
                {
                    for ( let ped of request.data.results )
                    {
                        pedidos.push( new Pedido( ped ) );
                    }

                } else
                {
                    break;
                }

                if ( request.data.response && request.data.response.paging.end )
                {
                    break;
                }

            } else
            {
                break;
            }
        }


        return pedidos;

    }

    public static async HojaDePisoPedidos ( hoja: number, soloPendientes: boolean = true ): Promise<Pedido[]>
    {
        let request = new apiRequest( `/pedidos` );
        request.params = {
            solo_id: 'S',
            hoja_piso: hoja
        };

        if ( soloPendientes )
            request.params.estado = 'en-proceso';

        if ( await request.get() )
        {
            return request.data.map( ( x: any ) => new Pedido( x ) );
        }
        return [];

    }

    public static async Marca ( Marca: string, Limite: number, tipos: Pedidos.Tipos[] ): Promise<Pedido[]>
    {
        let req = new apiRequest();
        req.path = '/pedidos/marcas/' + Marca;
        if ( Limite )
            req.body.limite = Limite;
        if ( tipos && tipos.hasRows() )
            req.body.tipos = tipos.map( x => x.Id ).join( ',' );
        if ( await req.post() )
        {
            return req.data.map( ( x: { id: number; } ) => { let e = new Pedido(); e.Id = x.id; return e; } );
        }
        return [];
    }

    public static async ComprobarImportarExcel ( archivo: any ): Promise<{ encabezados: string[]; columnas: Array<string[]>; }>
    {
        let req = new apiRequest();
        req.path = '/pedidos/importar/excel/1';
        req.useformData = true;
        req.formData.append( 'file', archivo );
        if ( await req.post() )
        {
            return req.data;
        }
        return null;
    }

    public get HayProblemasParaFacturar (): boolean
    {
        return this.ProblemasParaFacturar.hasRows();
    }
    public ProblemasParaFacturar: string[] = [];
    public ProblemasParaFacturarPorTipo: { Tipo: string, Error: string; }[] = [];

    public get ProblemasParaFacturarCliente (): { Tipo: string, Error: string; }[] { return this.ProblemasParaFacturarPorTipo.filter( x => x.Tipo == 'cliente' ); }
    public get ProblemasParaFacturarEnvio (): { Tipo: string, Error: string; }[] { return this.ProblemasParaFacturarPorTipo.filter( x => x.Tipo == 'envio' ); }
    public get ProblemasParaFacturarPagos (): { Tipo: string, Error: string; }[] { return this.ProblemasParaFacturarPorTipo.filter( x => x.Tipo == 'pagos' ); }
    public get ProblemasParaFacturarItems (): { Tipo: string, Error: string; }[] { return this.ProblemasParaFacturarPorTipo.filter( x => x.Tipo == 'items' ); }

    public get HayProblemasParaFacturarCliente (): boolean { return this.ProblemasParaFacturarCliente.hasRows(); }
    public get HayProblemasParaFacturarEnvio (): boolean { return this.ProblemasParaFacturarEnvio.hasRows(); }
    public get HayProblemasParaFacturarPagos (): boolean { return this.ProblemasParaFacturarPagos.hasRows(); }
    public get HayProblemasParaFacturarItems (): boolean { return this.ProblemasParaFacturarItems.hasRows(); }

    public ComprobarFacturacion ( test?: boolean ): string[]
    {

        let e: string[] = [];
        let a: { Tipo: string, Error: string; }[] = [];
        try
        {
            if ( this.Tipo.esPlataforma && !this.IdExterna )
            {
                e.push( 'El pedido debe tener un número de carrito u operación' );
                a.push( { Tipo: 'pedido', Error: 'El pedido debe tener un número de carrito u operación' } );
            }

            /* CLIENTE */

            if ( !this.Cliente.esClienteMadrePlataformas )
            {

                if ( this.Cliente.Persona.esJuridica )
                {
                    if ( !this.Cliente.RazonSocial.trim() )
                    {
                        e.push( 'El cliente debe tener una razón social' );
                        a.push( { Tipo: 'cliente', Error: 'El cliente debe tener una razón social' } );
                    }

                } else
                {
                    if ( !this.Cliente.Vista.NombreCompleto.trim() )
                    {
                        e.push( 'El cliente debe tener un nombre' );
                        a.push( { Tipo: 'cliente', Error: 'El cliente debe tener un nombre' } );
                    }
                }

                if ( this.Cliente.Cuit && !validarCuit( this.Cliente.Cuit ) )
                {
                    e.push( 'El CUIT no es válido' );
                    a.push( { Tipo: 'cliente', Error: 'El CUIT no es válido' } );
                }

                if ( this.Cliente.CondicionIva.FacturaA )
                {
                    if ( !validarCuit( this.Cliente.Cuit ) )
                    {
                        e.push( 'El CUIT no es válido para comprobantes A' );
                        a.push( { Tipo: 'cliente', Error: 'El CUIT no es válido para comprobantes A' } );
                    }

                    if ( !this.Cliente.Direccion.Valida )
                    {
                        e.push( 'La dirección fiscal no puede estar vacia' );
                        a.push( { Tipo: 'cliente', Error: 'La dirección fiscal no puede estar vacia' } );
                    }

                }

            }


            /* ENVIO */
            if ( this.Envio.Tipo.esNoEspecificado )
            {
                e.push( 'Se debe especificar un tipo de envío' );
                a.push( { Tipo: 'envio', Error: 'Se debe especificar un tipo de envío' } );
            }

            else
            {
                if ( !this.Envio.Tipo.esRetiraCliente && !this.Envio.Tipo.esPlataforma && !this.Envio.Tipo.esCuentaCorriente )
                {
                    if ( !this.Envio.Direccion.Valida )
                    {
                        e.push( 'La dirección de envío no puede estar vacia' );
                        a.push( { Tipo: 'envio', Error: 'La dirección de envío no puede estar vacia' } );
                    }

                    if ( !this.Envio.EmpresaLogistica || !this.Envio.EmpresaLogistica.Existe )
                    {
                        e.push( 'Se debe especificar una empresa de correo' );
                        a.push( { Tipo: 'envio', Error: 'Se debe especificar una empresa de correo' } );
                    }

                    if ( this.Envio.Tipo.esPropio && this.Envio.Importes.Propio <= 0 )
                    {
                        e.push( 'Se debe especificar un costo de envio para envios a cuenta de la empresa' );
                        a.push( { Tipo: 'envio', Error: 'Se debe especificar un costo de envio para envios a cuenta de la empresa' } );
                    }

                    if ( this.Envio.Tipo.esPickit && this.Envio.Importes.Propio <= 0 )
                    {
                        e.push( 'Se debe especificar un costo para el envio' );
                        a.push( { Tipo: 'envio', Error: 'Se debe especificar un costo de envio' } );
                    }

                    if ( this.Envio.Tipo.esEnvioPack && this.Envio.Importes.Propio <= 0 )
                    {
                        e.push( 'Se debe especificar un costo para el envio' );
                        a.push( { Tipo: 'envio', Error: 'Se debe especificar un costo de envio' } );
                    }

                    if ( this.Envio.Tipo.esContraEntrega && this.Envio.Importes.Cliente <= 0 )
                    {
                        e.push( 'Se debe especificar un costo estimado de envio para envios contraentrega' );
                        a.push( { Tipo: 'envio', Error: 'Se debe especificar un costo estimado de envio para envios contraentrega' } );
                    }

                    if ( this.Envio.Tipo.esEnvioGratis && this.Envio.Importes.Cliente <= 0 )
                    {
                        e.push( 'Se debe especificar un costo estimado de envio para envios gratuitos' );
                        a.push( { Tipo: 'envio', Error: 'Se debe especificar un costo estimado de envio para envios gratuitos' } );
                    }

                }

            }

            /* PAGOS */
            if ( !this.HabilitaPagoPresencial )
            {
                if ( this.Tipo.esMercadoLibre || this.Tipo.esTiendaIntex || this.Tipo.esPlataforma )
                {
                    if ( this.Tags.Pagado == 'N' )
                    {
                        e.push( 'No se encuentran pagos que cubran esta venta' );
                        a.push( { Tipo: 'pagos', Error: 'No se encuentran pagos que cubran esta venta' } );
                    }
                    else if ( this.Tags.Pagado == 'INS' )
                    {
                        e.push( 'El total pagado es insuficiente' );
                        a.push( { Tipo: 'pagos', Error: 'El total pagado es insuficiente' } );
                    }


                    if ( this.Importes.Percepciones > 0 )
                    {
                        if ( !this.NoAplicaIIBB &&

                            this.Importes.Pagado < ( ( this.Importes.FinalConEnvio + this.Importes.Percepciones ) - 10 ) )
                        {
                            e.push( 'No se encontró pago de Ingresos Brutos' );
                            a.push( { Tipo: 'pagos', Error: 'No se encontró pago de Ingresos Brutos' } );
                        }
                    }
                }
            }

            /* ITEMS */
            if ( this.Items.hasRows() )
            {
                if ( this.Items.filter( x => x.esDesconocido ).hasRows() )
                {
                    e.push( 'Hay items con codigos erroneos o desconocidos' );
                    a.push( { Tipo: 'items', Error: 'Hay items con codigos erroneos o desconocidos' } );
                }

                if ( this.Items.filter( x => x.PrecioUnitario.Neto <= 0 && ( !x.PrecioFijado || x.PrecioFijado.Lista.Neto == 0 ) ).hasRows() )
                {
                    e.push( 'Hay items con precio cero o negativo' );
                    a.push( { Tipo: 'items', Error: 'Hay items con precio cero o negativo' } );
                }

                if ( this.Items.filter( x => x.Cantidad <= 0 ).hasRows() )
                {
                    e.push( 'Hay items con cantidad cero o negativa' );
                    a.push( { Tipo: 'items', Error: 'Hay items con cantidad cero o negativa' } );
                }

            } else
            {
                e.push( 'Esta venta no tiene items' );
                a.push( { Tipo: 'items', Error: 'Esta venta no tiene items' } );
            }

        } catch ( e )
        {
            Log( e );
        }

        this.ProblemasParaFacturar = e;
        this.ProblemasParaFacturarPorTipo = a;
        return e;
    }

    public static async URLListadoLlamados ( filtros: any, ids?: number[] ): Promise<string>
    {
        let req = new apiRequest();
        req.timeOut = 10000000;
        req.path = '/pedidos/listado/llamados';
        if ( ids )
        {
            req.body.ids = ids.join( ',' );
        } else
        {
            //req.body.filtros = filtros;
        }

        req.params.response_type = 'pdf';
        if ( await req.post() )
        {
            return req.data.u;
        }
    }

    public static async URLListado ( filtros: any, ids?: number[] ): Promise<string>
    {
        let req = new apiRequest();
        req.timeOut = 10000000;
        req.path = '/pedidos/listado';
        if ( ids )
        {
            req.body.ids = ids.join( ',' );
        } else
        {
            req.body.filtros = filtros;
        }

        req.params.response_type = 'pdf';
        if ( await req.post() )
        {
            return req.data.u;
        }
    }

    ComprobarTotales ()
    {
        this.Importes.Final = 0;
        this.Importes.Neto = 0;
        this.Importes.Iva = 0;
        this.Importes.Descuento = 0;

        for ( let item of this.Items )
        {
            item.ComprobarTotales();
            this.Importes.Final += item.Importes.Final;
            this.Importes.Neto += item.Importes.Neto;
            this.Importes.Iva += item.Importes.IVA;
            this.Importes.Descuento += item.Importes.Descuento.Monto;
        }

        this.Importes.FinalConEnvio = this.Importes.Final + this.Envio.Importes.Propio;
        this.Importes.EnvioNeto = this.Envio.Importes.Propio / 1.21;
        this.Importes.EnvioFinal = this.Envio.Importes.Propio;

    }

    public async SubirDeclararionIIBB ( file: File | string ): Promise<boolean>
    {
        let req = new apiRequest();
        req.timeOut = 100000;
        if ( isString( file ) )
        {
            req.path = `/pedidos/${ this.Id }/declaracionibb/url`;
            req.body = { url: file };
        }
        else
        {
            req.path = `/pedidos/${ this.Id }/declaracionibb/archivo`;
            req.useformData = true;
            req.formData.append( 'file', file );
        }
        if ( await req.post() )
        {
            this.NoAplicaIIBB = true;
            this.DeclaracionBienDeUso = req.data.u;
            return true;
        }
    }

    public async EliminarDeclararionIIBB (): Promise<boolean>
    {
        let req = new apiRequest();
        req.timeOut = 100000;
        req.path = `/pedidos/${ this.Id }/declaracionibb/archivo`;

        if ( await req.delete() )
        {
            this.NoAplicaIIBB = false;
            this.DeclaracionBienDeUso = '';
            return true;
        }
    }

    public async DesvincularPago ( pago: number ): Promise<boolean>
    {
        let req = new apiRequest();
        req.timeOut = 100000;
        req.path = `/pedidos/${ this.Id }/pagos`;
        req.params.pagos = pago;
        if ( await req.delete() )
        {
            return true;
        }
    }

    public async ModificarLlamado ( llamado: string ): Promise<boolean>
    {
        let req = new apiRequest();
        req.timeOut = 100000;
        req.path = `/pedidos/${ this.Id }`;
        req.params.llamados_postventa = llamado;
        if ( await req.put() )
        {
            this.Tags.Llamados = llamado;
            return true;
        }
    }

}